import { render, staticRenderFns } from "./crudContactInterested.vue?vue&type=template&id=dd3c145c&"
import script from "./crudContactInterested.vue?vue&type=script&lang=js&"
export * from "./crudContactInterested.vue?vue&type=script&lang=js&"
import style0 from "./crudContactInterested.vue?vue&type=style&index=0&id=dd3c145c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports